<div class="feeders">
  <div class="feeders__toolbar">
    <div class="feeders__search">
      <em class="fa fa-search feeders__search-icon" aria-hidden="true"></em>
      <input
        class="form-control"
        type="search"
        name="name"
        [ngModel]="filters.name"
        (ngModelChange)="onNameChange($event)"
        [placeholder]="'panel-alerts.search-feeder' | translate"
      />
    </div>

    <select
      class="form-control feeders__status"
      name="statusFeeders"
      [ngModel]="filters.statusFeeders"
      (ngModelChange)="onStatusChange($event)"
    >
      <option *ngFor="let option of statusOptions" [value]="option.value">
        {{ option.label_key | translate }}
      </option>
    </select>

    <div class="feeders__last-response">
      <ng-container *ngIf="lastResponse; else noResponse">
        {{ "panel-alerts.last-response" | translate }} {{ lastResponse }}
      </ng-container>
      <ng-template #noResponse>{{ "panel-alerts.no-response-yet" | translate }}</ng-template>
    </div>
  </div>

  <div class="feeders__list frame-rectangle">
    <app-panel-feeder-card
      *ngFor="let feeder of feeders; trackBy: trackByFeeder"
      [feeder]="feeder"
      [sentCommands]="sentCommands"
      [timezone]="timezone"
      (toggleCheck)="onToggle($event)"
      (retry)="onRetry($event)"
    ></app-panel-feeder-card>

    <div class="feeders__empty" *ngIf="feeders.length === 0">
      <p class="m-0">{{ "panel-alerts.no-alerts-available" | translate }}</p>
    </div>
  </div>
</div>
